let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_TICKET": "Create Support Request",
    "LBL_VIEW_TICKET": "View Support Request",
    "LBL_PI_NAME": "PI Name",
    "LBL_PI_MOBILE": "PI Mobile",
    "LBL_REQUEST_BY": "Request By",
    "LBL_PI_PROFESSIONAL": "PI Professional",
    "LBL_CREATED_BY": "Created By",
    "LBL_PARENT_ID": "Parent ID",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_REQUEST_TO":"Request To",
    "LBL_TICKET_TYPE":"Support Request Type",
    "LBL_ADD_TICKETS":"Add Support Request",
    "LBL_TICKET_DESC":"Support Request Description",
    "LBL_ED_SUPPORT_DOC":"Select File",
    "LBL_ED_SUPPORT_REQUEST":"ED Support Request",
    "LBL_TICKET_STATUS":"Support Request Status",
    "LBL_EDIT_TICKETS":"Edit Support Request",
    "LBL_DOCUMENT":"Support Request Document",
    "LBL_TICKET_NUMBER":"Support Request No.",
    "LBL_RESOLVE_REMARK":"Enter Resolve Remark",
    "LBL_RESOLVE_REMARK_TEXT":"Resolve Remark",
    "LBL_CANCEL_REMARK":"Enter Cancel Remark",
    "LBL_FILE_SIZE":"You can select upto 5 files & upto 7MB at once",
}

export default language;
